import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getQrCodeImages = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
    STORE_BASE_URL +
    '/store/api/secure/v1/store/' +
    storeId +
    '/store-customer/' +
    id +
    '/order/' +
    orderId +
    '/qr-code-new/html',
      // STORE_BASE_URL +
      // '/store/api/secure/v1/store/' +
      // storeId +
      // '/store-customer/' +
      // id +
      // '/order/' +
      // orderId +
      // '/qr-code/html',
      // '/store/api/secure/v1/store/' +
      // storeId +
      // '/store-customer/' +
      // id +
      // '/order/' +
      // orderId +
      // '/qr-code-html',
    headers: getHeaders(),
  });
};

export const getQrCodeImages2 = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/qr-code-new/png',
    headers: getHeaders(),
  });
};

export const getQrCodeServiceWiseImages = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/qr-code-service-wise/png',
    headers: getHeaders(),
  });
};

export const getQrCodeServiceWiseHtml = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/qr-code-service-wise/html',
    headers: getHeaders(),
  });
};

export const getQrCodeImagesImage = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/qr-code/png/image',
    headers: getHeaders(),
  });
};

export const getQrCodeText = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/qr-code-text',
    headers: getHeaders(),
  });
};

export const getQrCodeTextLabel = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/qr-code-text-print',      
    headers: getHeaders(),
  });
};

export const printedQrCodeImages = (id, storeId, orderId,data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/qr-code-text-print',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getQrCodeImageLink = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/qr-code-image',
    headers: getHeaders(),
  });
};